package com.fireavert.tenants.client

import com.fireavert.cache.client.Preferences
import com.fireavert.common.ApiRepository
import com.fireavert.common.Try
import com.fireavert.logging.Logger
import com.fireavert.tenants.data_models.TenantModel
import com.fireavert.tenants.data_models.requests.CreateTenantRequest
import com.fireavert.tenants.data_models.requests.UpdateTenantRequest
import com.fireavert.user.data_models.TokenRefreshService
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.withContext

class ApiTenantRepository(
    ioContext: CoroutineDispatcher,
    tokenRefreshService: TokenRefreshService,
    private val dataSource: TenantDataSource,
    private val preferences: Preferences,
    private val logger: Logger
) : ApiRepository(ioContext = ioContext, tokenRefreshService = tokenRefreshService),
    ClientTenantRepository {

    override suspend fun getCurrentTenantForUnit(unitId: Int): Try<TenantModel?> =
        withContext(ioContext) {
            callWithRefresh {
                dataSource.getCurrentTenantForUnit(preferences.token, unitId)
            }
        }

    override suspend fun getTenantsForUnit(unitId: Int): Try<List<TenantModel>> =
        withContext(ioContext) {
            callWithRefresh {
                dataSource.getTenantsForUnit(preferences.token, unitId)
            }
        }

    override suspend fun createTenant(tenant: TenantModel): Try<TenantModel> =
        withContext(ioContext) {
            val request = CreateTenantRequest(
                firstName = tenant.firstName,
                lastName = tenant.lastName,
                email = tenant.email,
                phoneOneNumber = tenant.phoneOneNumber,
                phoneOneNumberLocation = tenant.phoneOneNumberLocation,
                phoneTwoNumber = tenant.phoneTwoNumber,
                phoneTwoNumberLocation = tenant.phoneTwoNumberLocation,
                status = tenant.status,
                unitId = tenant.unitId,
                textsUnlocked = tenant.textsUnlocked,
                emailUnlocked = tenant.emailUnlocked,
                hasPet = tenant.hasPet
            )
            callWithRefresh {
                dataSource.createTenant(preferences.token, request)
            }
        }

    override suspend fun updateTenant(tenant: TenantModel): Try<TenantModel> =
        withContext(ioContext) {
            val request = UpdateTenantRequest(
                firstName = tenant.firstName,
                lastName = tenant.lastName,
                email = tenant.email,
                phoneOneNumber = tenant.phoneOneNumber,
                phoneOneNumberLocation = tenant.phoneOneNumberLocation,
                phoneTwoNumber = tenant.phoneTwoNumber,
                phoneTwoNumberLocation = tenant.phoneTwoNumberLocation,
                status = tenant.status,
                unitId = tenant.unitId,
                textsUnlocked = tenant.textsUnlocked,
                emailUnlocked = tenant.emailUnlocked,
                hasPet = tenant.hasPet
            )
            callWithRefresh {
                dataSource.updateTenant(preferences.token, tenant.id ?: 0, request)
            }
        }
}